function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettlersGameloop = /*#__PURE__*/function () {
  function SettlersGameloop() {
    _classCallCheck(this, SettlersGameloop);
  }
  return _createClass(SettlersGameloop, [{
    key: "handleGameLoop",
    value: (
    /*
     * Core Game Logic
     * Commands: init, generate_map, winner
     */
    function () {
      var _handleGameLoop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var settlers_self, qe, mv, i, winner, player, lastcard, html, _player, cardname, _player2, _cardname, _player3, _cardname2, _player4, _cardname3, resources, msg, _iterator, _step, j, _player5, _cardname4, resource, lootCt, _i, am_i_a_victim, _j, _i2, _player6, purchase, key, cost, _iterator2, _step2, _resource, _player7, _resource2, target, _player8, newRoads, _iterator3, _step3, road, canbackup, _player9, slot, roadInfo, _player0, _player1, city, logMsg, _iterator4, _step4, hextile, bounty, _player10, _slot, adj_road_owners, _newRoads, bisect, _iterator5, _step5, _road, _i4, owner, _i3, _player11, _player12, _slot2, _loop, _ret, _i5, offering_player, stuff_on_offer, stuff_in_return, _player13, _offering_player, receiving_player, _stuff_on_offer, _stuff_in_return, accepting_player, _offering_player2, tradeOut, tradeIn, _i6, _j2, _i7, _j3, refusing_player, _offering_player3, _player14, outCount, outResource, inCount, inResource, check, _iterator6, _step6, r, _i8, _j4, _player15, statushtml, timer, _statushtml, _player16, d1, d2, roll, _r, record, firstMsg, playersToDiscard, _i9, eo, playersToGo, discardString, confirmsNeeded, amIPlaying, idx, _iterator7, _step7, _i0, player_who_rolled, _player17, _player18, hex, temp, hexId, h, hexName, _iterator8, _step8, _city, thief, victim, loot, _record, x, victim_name, _player19, _player20, _i1;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              settlers_self = this; ///////////
              // QUEUE //
              ///////////
              if (!(this.game.queue.length > 0)) {
                _context2.n = 44;
                break;
              }
              //
              // catch win condition
              //
              if (this.browser_active) {
                this.displayPlayers(); //Is it enough to update the player huds each iteration, board doesn't get redrawn at all?
              }
              qe = this.game.queue.length - 1;
              mv = this.game.queue[qe].split('\t'); //console.log("QUEUE: " + this.game.queue);
              if (!(mv[0] == 'init')) {
                _context2.n = 1;
                break;
              }
              this.game.queue.splice(qe, 1);
              this.game.state.placedCity = null; //We are in game play mode, not initial set up
              this.game.state.lastroll = [0, 0];
              this.game.queue.push('round');
              this.game_help.hide();

              //
              // what does this do and why is it not in an init function?
              //
              // initX()
              //
              this.status = [];
              $('.dark').css('background-color', 'unset');
              $('#settlers-hud-controls .option').css('visibility', 'visible');
              return _context2.a(2, 1);
            case 1:
              if (!(mv[0] == 'initial_placement')) {
                _context2.n = 2;
                break;
              }
              this.game.queue.splice(qe, 1);
              this.game_help.render({
                title: 'Initial Placement',
                text: 'A strong opening <em>maximizes</em> your chances of producing a <em>variety</em> of resources, the dots indicate the likelihood of a tile producing. 6/8/5/9 > 2/12/3/11',
                img: '/settlers/img/welcome3.png',
                line1: 'where',
                line2: 'to place?',
                id: 'welcome',
                duration: 5000
              });
              return _context2.a(2, 1);
            case 2:
              if (!(mv[0] == 'round')) {
                _context2.n = 3;
                break;
              }
              for (i = this.game.players.length; i > 0; i--) {
                this.game.queue.push("play\t".concat(i));
              }
              return _context2.a(2, 1);
            case 3:
              if (!(mv[0] == 'generate_map')) {
                _context2.n = 4;
                break;
              }
              console.log('Building the map');
              this.game.queue.splice(qe, 1);
              this.generateMap();
              this.addPortsToGameboard();
              if (this.browser_active && this.game.player == 0) {
                this.displayBoard();
              }
              //
              // we should not be running this ahead of READY
              // because it creates information in generateMap
              // that disappears,
              //
              this.saveGame(this.game.id);
              return _context2.a(2, 1);
            case 4:
              if (!(mv[0] == 'winner')) {
                _context2.n = 5;
                break;
              }
              // 0-index
              winner = parseInt(mv[1]);
              this.game.queue = [];
              this.game.canProcess = true;
              this.updateLog("".concat(this.formatPlayer(winner + 1), " is ").concat(this.winState.name, " and wins the game!"));
              //this.stats_overlay.render(this.game.playerNames[winner]);
              this.card_overlay.render({
                player: winner + 1,
                card: 'Winner'
              });
              if (this.gameOverCallback) {
                this.gameOverCallback();
              } else {
                this.triggerGameOver(this.game.players[winner]);
              }
              return _context2.a(2, 0);
            case 5:
              if (!(mv[0] == 'buy_card')) {
                _context2.n = 8;
                break;
              }
              // 1-index
              player = parseInt(mv[1]);
              this.game.queue.splice(qe, 1);
              this.updateLog("".concat(this.formatPlayer(player), " bought a ").concat(this.card.name, " card"));
              this.game.state.canTrade = false;

              //the player will update their devcard count on next turn
              if (!(player != this.game.player)) {
                _context2.n = 6;
                break;
              }
              this.animateDevCard(player);
              this.game.state.players[player - 1].devcards.push('x'); //Add card for display
              this.game.status = "".concat(this.game.playerNames[player - 1], " bought a ").concat(this.card.name, " card"), 1;
              this.hud.updateStatus(this.game.status);
              this.hud.updateMenu([]);
              this.hud.updateCards([]);
              return _context2.a(2, 0);
            case 6:
              $('#settlers-hud-controls #playcard').addClass('enabled').addClass('flashme');
              lastcard = this.game.deck[0].cards[this.game.deck[0].hand[this.game.deck[0].hand.length - 1]];
              html = "<span class=\"tip\">".concat(lastcard.title, "\n                        <div class=\"tiptext\">").concat(this.rules[lastcard.action], "</div>\n                      </span>");
              console.log('Current status: ' + this.game.state.canPlayCard);
              if (lastcard.action == 0 && this.game.state.canPlayCard !== false) {
                this.game.state.players[player - 1].devcards.push(this.game.deck[0].hand.pop());
                this.game.state.canPlayCard = true;
              }
              this.updateStatus("<div class=\"player-notice\">you bought ".concat(html, "</div>"), 1);
            case 7:
              return _context2.a(2, 1);
            case 8:
              if (!(mv[0] == 'vp')) {
                _context2.n = 9;
                break;
              }
              _player = parseInt(mv[1]);
              cardname = mv[2];
              this.game.queue.splice(qe, 1);

              // show overlay
              this.card_overlay.render({
                player: _player,
                card: cardname
              });

              //Score gets recounted a lot, so we save the number of VP cards
              this.game.state.players[_player - 1].vpc++; //Number of victory point cards for the player
              if (_player != this.game.player) {
                this.game.state.players[_player - 1].devcards.pop(); //Remove card (for display)
              }
              this.updateLog("".concat(this.formatPlayer(_player), " played ").concat(cardname, " to gain 1 victory point"));
              this.game.status = "".concat(this.game.playerNames[_player - 1], " played ").concat(cardname, " to gain 1 victory point"), 1;
              this.hud.updateStatus(this.game.status);
              this.hud.updateMenu([]);
              this.hud.updateCards([]);
              return _context2.a(2, 1);
            case 9:
              if (!(mv[0] == 'road_building')) {
                _context2.n = 10;
                break;
              }
              _player2 = parseInt(mv[1]);
              _cardname = mv[2];
              this.game.queue.splice(qe, 1);
              if (_player2 != this.game.player) {
                this.card_overlay.render({
                  player: _player2,
                  card: _cardname
                });
                this.game.state.players[_player2 - 1].devcards.pop(); //Remove card (for display)
              }
              this.updateLog("".concat(this.formatPlayer(_player2), " played ").concat(_cardname));
              return _context2.a(2, 1);
            case 10:
              if (!(mv[0] == 'play_knight')) {
                _context2.n = 11;
                break;
              }
              _player3 = parseInt(mv[1]);
              _cardname2 = mv[2];
              this.game.queue.splice(qe, 1);
              this.updateLog("".concat(this.formatPlayer(_player3), " played a ").concat(_cardname2, "!"));
              if (_player3 != this.game.player) {
                this.card_overlay.render({
                  player: _player3,
                  card: _cardname2
                });
                this.game.state.players[_player3 - 1].devcards.pop(); //Remove card (for display)
              }
              //Update Army!
              this.game.state.players[_player3 - 1].knights++;
              this.checkLargestArmy(_player3);
              this.game.stats.move_bandit[_player3 - 1]++;

              //Move Bandit
              if (this.game.player == _player3) {
                this.playerPlayBandit(false);
              } else {
                this.game.status = "".concat(this.game.playerNames[_player3 - 1], " played a ").concat(_cardname2, " and is moving the ").concat(this.b.name, "...");
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              return _context2.a(2, 0);
            case 11:
              if (!(mv[0] == 'year_of_plenty')) {
                _context2.n = 12;
                break;
              }
              _player4 = parseInt(mv[1]);
              _cardname3 = mv[2];
              resources = JSON.parse(mv[3]); //The two resources the player picked
              this.game.queue.splice(qe, 1);
              msg = "".concat(this.formatPlayer(_player4), " played ").concat(_cardname3, " for ");
              _iterator = _createForOfIteratorHelper(resources);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  j = _step.value;
                  //Should always be 2
                  this.game.state.players[_player4 - 1].resources.push(j);
                  msg += j + ' and ';
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              if (_player4 != this.game.player) {
                this.card_overlay.render({
                  player: _player4,
                  card: _cardname3
                });
                this.game.state.players[_player4 - 1].devcards.pop(); //Remove card (for display)
              }
              msg = msg.substring(0, msg.length - 5) + '.';
              this.updateLog(msg);
              return _context2.a(2, 1);
            case 12:
              if (!(mv[0] == 'monopoly')) {
                _context2.n = 13;
                break;
              }
              _player5 = parseInt(mv[1]);
              _cardname4 = mv[2];
              resource = mv[3];
              this.game.queue.splice(qe, 1);
              lootCt = 0; //Collect all instances of the resource
              for (_i = 0; _i < this.game.state.players.length; _i++) {
                if (_player5 != _i + 1) {
                  am_i_a_victim = false;
                  for (_j = 0; _j < this.game.state.players[_i].resources.length; _j++) {
                    if (this.game.state.players[_i].resources[_j] == resource) {
                      am_i_a_victim = true;
                      lootCt++;
                      this.game.state.players[_i].resources.splice(_j, 1);
                      _j--;
                    }
                  }
                  if (am_i_a_victim && this.game.player == _i + 1) {
                    this.game.queue.push("ACKNOWLEDGE\t".concat(this.game.playerNames[_player5 - 1], " stole all your ").concat(resource));
                  } else if (this.game.player == _i + 1) {
                    this.game.status = "".concat(this.game.playerNames[_player5 - 1], " played ").concat(_cardname4, " for ").concat(resource), 1;
                    this.hud.updateStatus(this.game.status);
                    this.hud.updateMenu([]);
                    this.hud.updateCards([]);
                  }
                }
              }
              //Award to Player
              for (_i2 = 0; _i2 < lootCt; _i2++) this.game.state.players[_player5 - 1].resources.push(resource);
              if (this.game.player == _player5) {
                this.game.status = "<div class=\"player-notice\">you collected ".concat(lootCt, " ").concat(this.formatResource(resource), "</div>"), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              } else {
                this.card_overlay.render({
                  player: _player5,
                  card: _cardname4
                });
                this.game.state.players[_player5 - 1].devcards.pop(); //Remove card (for display)
              }
              this.updateLog("".concat(this.formatPlayer(_player5), " played ").concat(_cardname4, " for ").concat(this.formatResource(resource), ", collecting ").concat(lootCt, "."));
              return _context2.a(2, 1);
            case 13:
              if (!(mv[0] == 'undo_build')) {
                _context2.n = 14;
                break;
              }
              this.game.queue.splice(qe, 1);
              _player6 = parseInt(mv[1]);
              purchase = parseInt(mv[2]);
              key = this.r.name;
              if (purchase == 1) {
                key = this.c1.name;
              }
              if (purchase == 2) {
                key = this.c2.name;
              }
              this.updateLog("".concat(this.formatPlayer(_player6), " decided against building a ").concat(key));
              if (_player6 != this.game.player) {
                this.game.status = "".concat(this.game.playerNames[_player6 - 1], " changed their mind about building"), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              } else {
                this.updateStatus("".concat(this.game.playerNames[_player6 - 1], " cancelled the build"), 1);
              }
              cost = this.priceList[purchase];
              _iterator2 = _createForOfIteratorHelper(cost);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _resource = _step2.value;
                  this.game.state.players[_player6 - 1].resources.push(_resource);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              return _context2.a(2, 1);
            case 14:
              if (!(mv[0] == 'spend_resource')) {
                _context2.n = 15;
                break;
              }
              _player7 = parseInt(mv[1]);
              _resource2 = mv[2]; //string name: "ore", "brick", etc
              target = this.game.state.players[_player7 - 1].resources.indexOf(_resource2);
              if (target >= 0) {
                this.game.state.players[_player7 - 1].resources.splice(target, 1);
              } else {
                console.log('Resource not found...', _resource2, this.game.state.players[_player7 - 1]);
              }

              // Bandit discards
              if (this.game.state.bandit) {
                this.game.stats.discarded[_resource2][_player7 - 1]++;
              }
              this.game.queue.splice(qe, 1);
              return _context2.a(2, 1);
            case 15:
              if (!(mv[0] == 'player_build_road')) {
                _context2.n = 16;
                break;
              }
              _player8 = parseInt(mv[1]);
              this.game.queue.splice(qe, 1);
              if (this.game.player == _player8) {
                if (mv[2] == 1) {
                  console.log('Last Placed City: ' + this.game.state.last_city);
                  newRoads = this.hexgrid.edgesFromVertex(this.game.state.last_city.replace('city_', ''));
                  _iterator3 = _createForOfIteratorHelper(newRoads);
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      road = _step3.value;
                      console.log('road: ', road);
                      this.addRoadToGameboard(road.substring(2), road[0]);
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }
                canbackup = parseInt(mv[3]) || 0;
                this.playerBuildRoad(mv[1], canbackup);
              } else {
                if (this.game.state.placedCity) {
                  this.hud.updateStatus("<div class=\"player-notice\">".concat(this.game.playerNames[_player8 - 1], " is placing a ").concat(this.r.name, "...</div>"));
                } else {
                  this.updateStatus("".concat(this.game.playerNames[_player8 - 1], " is building a ").concat(this.r.name, "..."));
                }
              }
              return _context2.a(2, 0);
            case 16:
              if (!(mv[0] == 'build_road')) {
                _context2.n = 17;
                break;
              }
              _player9 = parseInt(mv[1]);
              slot = mv[2];
              this.game.queue.splice(qe, 1);
              console.log('Receive build road');
              this.game.state.canTrade = false;
              this.game.state.roads.push({
                player: _player9,
                slot: slot
              });
              roadInfo = slot.split('_');
              this.addRoadToGameboard(roadInfo[2] + '_' + roadInfo[3], roadInfo[1]);

              //
              // This is kind of ridiculous, animation won't show up without a slight delay
              // but making buildroad async "breaks" caravan in that I won't unlock the new
              // road options before the game queue continues
              //
              if (this.game.player == _player9) {
                this.buildRoad(_player9, slot);
                this.updateStatus('you built a road', 1);
              } else {
                this.updateStatus("".concat(this.game.playerNames[_player9 - 1], " built a ").concat(this.r.name), 1);
                setTimeout(function () {
                  _this.buildRoad(_player9, slot);
                }, 100);
              }
              this.updateLog("".concat(this.formatPlayer(_player9), " built a ").concat(this.r.name));
              if (this.checkLongestRoad(_player9)) {
                console.log('Longest Road:', this.game.state.longestRoad.path);
              }
              return _context2.a(2, 1);
            case 17:
              if (!(mv[0] == 'player_build_city')) {
                _context2.n = 18;
                break;
              }
              _player0 = parseInt(mv[1]);
              this.game.state.playerTurn = _player0;
              this.playerbox.setActive(_player0);
              this.game.queue.splice(qe, 1);
              if (this.game.player == _player0) {
                this.playerBuildTown(mv[1], parseInt(mv[2]));
              } else {
                if (this.game.state.placedCity) {
                  this.hud.updateStatus("<div class=\"player-notice\">".concat(this.game.playerNames[_player0 - 1], " is placing a ").concat(this.c1.name, "...</div>"));
                } else {
                  this.updateStatus("".concat(this.game.playerNames[_player0 - 1], " is building a ").concat(this.c1.name, "..."));
                }
              }
              return _context2.a(2, 0);
            case 18:
              if (!(mv[0] == 'secondcity')) {
                _context2.n = 19;
                break;
              }
              _player1 = parseInt(mv[1]);
              city = mv[2];
              this.game.queue.splice(qe, 1);
              logMsg = "".concat(this.formatPlayer(_player1), " gains ");
              _iterator4 = _createForOfIteratorHelper(this.hexgrid.hexesFromVertex(city));
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  hextile = _step4.value;
                  bounty = this.game.state.hexes[hextile].resource;
                  if (bounty !== this.returnNullResource()) {
                    //DESERT ATTACK
                    logMsg += this.formatResource(bounty);
                    this.game.state.players[_player1 - 1].resources.push(bounty);
                    this.game.stats.production[bounty][_player1 - 1]++; //Initial starting stats
                    this.animateHarvest(_player1, bounty, hextile);
                  }
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              this.runAnimationQueue();
              this.updateLog(logMsg);
              return _context2.a(2, 0);
            case 19:
              if (!(mv[0] == 'build_city')) {
                _context2.n = 20;
                break;
              }
              _player10 = parseInt(mv[1]);
              _slot = mv[2];
              this.game.queue.splice(qe, 1);
              this.buildCity(_player10, _slot);
              if (this.game.player != _player10) {
                this.updateStatus("".concat(this.game.playerNames[_player10 - 1], " built a ").concat(this.c1.name), 1);
              } else {
                this.updateStatus("you built a ".concat(this.c1.name), 1);
              }
              this.game.state.canTrade = false;
              this.updateLog("".concat(this.formatPlayer(_player10), " built a ").concat(this.c1.name));

              //Check for edge case where the new city splits a (longest) road
              adj_road_owners = {};
              _newRoads = this.hexgrid.edgesFromVertex(_slot.replace('city_', ''));
              bisect = -1;
              _iterator5 = _createForOfIteratorHelper(_newRoads);
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  _road = _step5.value;
                  //Check if adjacent edge is a built road and if so, who owns it
                  for (_i4 = 0; _i4 < this.game.state.roads.length; _i4++) {
                    if (this.game.state.roads[_i4].slot == 'road_' + _road) {
                      if (!adj_road_owners[this.game.state.roads[_i4].player]) {
                        adj_road_owners[this.game.state.roads[_i4].player] = 0;
                      }
                      adj_road_owners[this.game.state.roads[_i4].player]++;
                    }
                  }
                  //Check if adjacent edge is part of longest road path (alternate method)
                  if (this.game.state.longestRoad.path.includes(_road)) {
                    bisect++;
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              if (bisect == 1) {
                for (owner in adj_road_owners) {
                  //If new town borders a road of the player with the longest road, recheck board to find longest road
                  if (adj_road_owners[owner] > 1 && owner != _player10 && owner == this.game.state.longestRoad.player) {
                    this.updateLog("New ".concat(this.c1.name, " bisects longest road, recalculating next longest road"));
                    this.game.state.longestRoad.player = 0; //unset longest road
                    //Check the person who had the longest road first so they have priority (in event of ties)
                    this.checkLongestRoad(owner);
                    //Check everyone else if they have a longer road now
                    for (_i3 = 1; _i3 <= this.game.players.length; _i3++) {
                      if (_i3 !== owner) {
                        this.checkLongestRoad(_i3);
                      }
                    }
                  }
                }
              }
              return _context2.a(2, 1);
            case 20:
              if (!(mv[0] == 'player_upgrade_city')) {
                _context2.n = 21;
                break;
              }
              _player11 = parseInt(mv[1]);
              this.game.queue.splice(qe, 1);
              if (this.game.player == _player11) {
                this.playerBuildCity(_player11, 1);
              } else {
                this.updateStatus("".concat(this.game.playerNames[_player11 - 1], " is upgrading to a ").concat(this.c2.name, "..."));
              }
              return _context2.a(2, 0);
            case 21:
              if (!(mv[0] == 'upgrade_city')) {
                _context2.n = 26;
                break;
              }
              _player12 = parseInt(mv[1]);
              _slot2 = mv[2];
              this.game.queue.splice(qe, 1);
              this.updateLog("".concat(this.formatPlayer(_player12), " upgraded a ").concat(this.c1.name, " to a ").concat(this.c2.name));
              if (this.game.player == _player12) {
                this.updateStatus("you upgraded to a ".concat(this.c2.name), 1);
              } else {
                this.game.status = "".concat(this.game.playerNames[_player12 - 1], " upgraded to a ").concat(this.c2.name), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              this.game.state.canTrade = false;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var divname;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      if (!(_this.game.state.cities[_i5].slot === _slot2)) {
                        _context.n = 1;
                        break;
                      }
                      _this.game.state.cities[_i5].level = 2;
                      //Player exchanges city for town
                      _this.game.state.players[_player12 - 1].cities--;
                      _this.game.state.players[_player12 - 1].towns++;
                      divname = '#' + _slot2;
                      $(divname).children('img').eq(0).fadeOut(400, 'linear', function () {
                        $(divname).html('');
                        $(_this.c2.svg).hide().delay(600).appendTo(divname).fadeIn(1200);
                      });
                      $(divname).addClass("p".concat(_this.game.colors[_player12 - 1]));
                      return _context.a(2, {
                        v: 1
                      });
                    case 1:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _i5 = 0;
            case 22:
              if (!(_i5 < this.game.state.cities.length)) {
                _context2.n = 25;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 23);
            case 23:
              _ret = _context2.v;
              if (!_ret) {
                _context2.n = 24;
                break;
              }
              return _context2.a(2, _ret.v);
            case 24:
              _i5++;
              _context2.n = 22;
              break;
            case 25:
              return _context2.a(2, 1);
            case 26:
              /* Trading Actions */

              //
              // trade advertisement
              //
              if (mv[0] == 'advertisement') {
                offering_player = parseInt(mv[1]);
                stuff_on_offer = JSON.parse(mv[2]);
                stuff_in_return = JSON.parse(mv[3]);
                this.game.queue.splice(qe, 1);
                this.game.state.ads[offering_player - 1].offer = stuff_on_offer;
                this.game.state.ads[offering_player - 1].ask = stuff_in_return;
                this.game.state.ads[offering_player - 1].ad = true;
                this.displayPlayers();
              }
              if (mv[0] == 'clear_advert') {
                _player13 = parseInt(mv[1]);
                this.game.queue.splice(qe, 1);
                console.log('CLEAR ADVERT for player:' + _player13);
                this.game.state.ads[_player13 - 1].offer = null;
                this.game.state.ads[_player13 - 1].ask = null;
                this.playerbox.updateGraphics('', _player13);
                this.displayPlayers();
              }
              //
              // Player A has offered another player a trade
              //
              if (!(mv[0] === 'offer')) {
                _context2.n = 29;
                break;
              }
              _offering_player = parseInt(mv[1]);
              receiving_player = parseInt(mv[2]);
              _stuff_on_offer = JSON.parse(mv[3]);
              _stuff_in_return = JSON.parse(mv[4]);
              this.game.queue.splice(qe, 1);
              if (!(_stuff_on_offer == null)) {
                _context2.n = 27;
                break;
              }
              return _context2.a(2);
            case 27:
              if (!(_stuff_in_return == null)) {
                _context2.n = 28;
                break;
              }
              return _context2.a(2);
            case 28:
              console.log('RECEIVED OFFER: ');
              console.log('RECEIVED OFFER: ' + JSON.stringify(_stuff_on_offer));
              console.log('RECEIVED OFFER: ' + JSON.stringify(_stuff_in_return));
              if (this.game.player == receiving_player) {
                this.game.state.ads[_offering_player - 1].offer = _stuff_on_offer;
                this.game.state.ads[_offering_player - 1].ask = _stuff_in_return;
                this.game.state.ads[_offering_player - 1].ad = false;
                this.updateLog("".concat(this.formatPlayer(_offering_player), " sent a trade offer to ").concat(this.formatPlayer(receiving_player), "."));
                this.displayPlayers();
              } else {
                this.game.state.ads[_offering_player - 1].offer = _stuff_on_offer;
                this.game.state.ads[_offering_player - 1].ask = _stuff_in_return;
                this.game.state.ads[_offering_player - 1].ad = true;
                this.updateLog("".concat(this.formatPlayer(_offering_player), " sent a public trade offer."));
              }
              this.displayPlayers();
              return _context2.a(2, 1);
            case 29:
              if (!(mv[0] === 'accept_offer')) {
                _context2.n = 30;
                break;
              }
              accepting_player = parseInt(mv[1]);
              _offering_player2 = parseInt(mv[2]);
              tradeOut = JSON.parse(mv[3]);
              tradeIn = JSON.parse(mv[4]);
              this.game.queue.splice(qe, 1);

              // let offering player know
              if (this.game.player == _offering_player2) {
                this.game.status = "".concat(this.game.playerNames[accepting_player - 1], " accepted your trade offer"), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              if (this.game.player == accepting_player) {
                this.game.status = "you completed a trade with ".concat(this.game.playerNames[_offering_player2 - 1]), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              if (this.game.player !== accepting_player && this.game.player !== _offering_player2) {
                this.game.status = "".concat(this.game.playerNames[_offering_player2 - 1], " and ").concat(this.game.playerNames[accepting_player - 1], " completed a trade"), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }

              //Offering Player
              for (_i6 in tradeOut) {
                //i is resource name, offer[i]
                for (_j2 = 0; _j2 < tradeOut[_i6]; _j2++) {
                  //Ignores zeros
                  this.game.queue.push('spend_resource\t' + _offering_player2 + '\t' + _i6); //Just easier to do this in the queue
                  this.game.state.players[accepting_player - 1].resources.push(_i6);
                }
              }
              for (_i7 in tradeIn) {
                //i is resource name, offer[i]
                for (_j3 = 0; _j3 < tradeIn[_i7]; _j3++) {
                  this.game.queue.push('spend_resource\t' + accepting_player + '\t' + _i7); //Just easier to do this in the queue
                  this.game.state.players[_offering_player2 - 1].resources.push(_i7);
                }
              }
              this.updateLog("".concat(this.formatPlayer(_offering_player2), " and ").concat(this.formatPlayer(accepting_player), " completed a trade."));
              console.log(JSON.parse(JSON.stringify(this.game.state.ads)));
              return _context2.a(2, 1);
            case 30:
              if (!(mv[0] === 'reject_offer')) {
                _context2.n = 31;
                break;
              }
              refusing_player = parseInt(mv[1]);
              _offering_player3 = parseInt(mv[2]);
              this.game.queue.splice(qe, 1);
              this.game.confirms_needed[refusing_player - 1] = 0; //Manually resolve
              if (this.game.player == _offering_player3) {
                this.updateStatus('your trade offer has been rejected', 1);
              }
              if (this.game.player == refusing_player) {
                this.game.status = "you rejected ".concat(this.game.playerNames[_offering_player3 - 1], "'s trade offer"), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
                this.game.state.ads[_offering_player3 - 1].offer = null;
                this.game.state.ads[_offering_player3 - 1].ask = null;
                this.playerbox.updateGraphics('', _offering_player3);
                this.displayPlayers();
              }
              this.updateLog("".concat(this.formatPlayer(refusing_player), " turned down a trade offer from ").concat(this.formatPlayer(_offering_player3), "."));
              console.log(JSON.parse(JSON.stringify(this.game.state.ads)));
              return _context2.a(2, 1);
            case 31:
              if (!(mv[0] === 'bank')) {
                _context2.n = 33;
                break;
              }
              _player14 = parseInt(mv[1]);
              outCount = parseInt(mv[2]);
              outResource = mv[3];
              inCount = parseInt(mv[4]);
              inResource = mv[5];
              this.game.queue.splice(qe, 1);

              // Check that this is possible first
              check = 0;
              _iterator6 = _createForOfIteratorHelper(this.game.state.players[_player14 - 1].resources);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  r = _step6.value;
                  if (r == outResource) {
                    check++;
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              if (!(check < outCount)) {
                _context2.n = 32;
                break;
              }
              console.warn('Attempted double trade!');
              return _context2.a(2, 1);
            case 32:
              // let offering player know
              if (this.game.player == _player14) {
                this.updateStatus('your bank trade is completed', 1);
              } else {
                this.updateStatus("".concat(this.game.playerNames[_player14 - 1], " traded with the bank"), 1);
              }
              for (_i8 = 0; _i8 < outCount; _i8++) {
                this.game.queue.push('spend_resource\t' + _player14 + '\t' + outResource);
                this.game.stats.banked[outResource][_player14 - 1]++;
              }
              for (_j4 = 0; _j4 < inCount; _j4++) {
                //Should always be 1
                this.game.state.players[_player14 - 1].resources.push(inResource);
                this.game.stats.traded[inResource][_player14 - 1]++;
              }
              this.updateLog("".concat(this.formatPlayer(_player14), " traded ").concat(outCount, "x").concat(this.formatResource(outResource), "<span> with the bank for </span>").concat(this.formatResource(inResource), "."));
              return _context2.a(2, 1);
            case 33:
              if (!(mv[0] == 'play')) {
                _context2.n = 34;
                break;
              }
              _player15 = parseInt(mv[1]);
              this.game.state.playerTurn = _player15;
              this.playerbox.setActive(_player15);
              this.setToolbarState('');
              if (this.game.player == _player15) {
                //Messaging to User
                statushtml = 'ROLL DICE:';
                $('#rolldice').html("<i class=\"fa-solid fa-dice\"></i>");
                $('#rolldice').addClass('enabled');
                timer = 3000;
                if (this.canPlayerPlayCard(true)) {
                  $('#playcard').addClass('enabled');
                  statushtml = 'YOUR TURN:';
                  timer = 5000;
                }
                this.updateStatus("".concat(statushtml));
                if (this.turn_limit) {
                  this.setShotClock('#rolldice', timer);
                } else {
                  this.promptMove('#rolldice', 7000);
                }

                // **********************************************************
                // > To DO rewrite this if we like the new dev card interface
                // **********************************************************

                //Or, choose menu option
                if (document.getElementById('rolldice')) {
                  document.getElementById('rolldice').onclick = function (e) {
                    e.currentTarget.onclick = null;
                    e.currentTarget.classList.remove('enabled');
                    settlers_self.addMove('roll\t' + _player15);
                    settlers_self.endTurn();
                    _this.updateStatus('rolling dice...');
                  };
                }
              } else {
                _statushtml = "".concat(this.game.playerNames[_player15 - 1], " rolling dice...");
                this.updateStatus("".concat(_statushtml));
              }
              //this.game.queue.splice(qe, 1);
              return _context2.a(2, 0);
            case 34:
              if (!(mv[0] == 'roll')) {
                _context2.n = 36;
                break;
              }
              _player16 = parseInt(mv[1]);
              this.game.queue.splice(qe - 1, 2);

              // everyone rolls the dice
              d1 = this.rollDice(6);
              d2 = this.rollDice(6);
              roll = d1 + d2; // Less bandit in early game
              while (roll == 7 && this.game.stats.history.length < 5) {
                console.log("Re-roll the 7 (you're welcome)!");
                d1 = this.rollDice(6);
                d2 = this.rollDice(6);
                roll = d1 + d2;
              }
              this.game.state.lastroll = [d1, d2];
              this.game.state.lastroll.sort();
              this.updateLog("".concat(this.formatPlayer(_player16), " rolled: ").concat(this.returnDiceImage(this.game.state.lastroll[1])).concat(this.returnDiceImage(this.game.state.lastroll[0])));
              this.playerbox.updateGraphics("<div class=\"last-roll\">".concat(this.returnDiceImage(d1)).concat(this.returnDiceImage(d2), "</div>"), _player16);
              this.game.stats.dice[roll]++; //Keep count of the rolls
              this.game.stats.dicePlayer[roll][_player16 - 1]++;
              for (_r in this.game.stats.famine) {
                this.game.stats.famine[_r]++;
              }
              this.game.stats.famine[roll] = 0;
              console.log('Settlers roll: ', roll, this.game.stats.famine);

              // board animation
              this.animateDiceRoll(roll);

              //this.setToolbarState("");

              //Regardless of outcome, player gets a turn
              this.game.queue.push("player_actions\t".concat(_player16));
              this.game.queue.push("enable_trading\t".concat(_player16)); //Enable trading after resolving bandit

              //Next Step depends on Dice outcome
              if (!(roll == 7)) {
                _context2.n = 35;
                break;
              }
              this.game.state.bandit = true;
              this.game.queue.push('roll_bandit\t' + _player16);
              record = {
                roll: 7,
                harvest: {},
                bandit: {},
                threatened: this.game.state.threatened.slice()
              };
              this.game.stats.history.push(record);
              firstMsg = this.game.player == _player16 ? 'you' : this.game.playerNames[_player16 - 1];
              firstMsg += " rolled <span class='die_value'>".concat(roll, "</span>");
              this.updateStatus(firstMsg, 1);

              //Manage discarding before bandit comes into play
              playersToDiscard = [];
              for (_i9 = 1; _i9 <= this.game.state.players.length; _i9++) {
                if (this.game.state.players[_i9 - 1].resources.length > 7 && this.game.state.robinhood !== _i9) {
                  playersToDiscard.push(_i9);
                }
              }
              if (playersToDiscard.length > 0) {
                this.resetConfirmsNeeded(playersToDiscard);
                this.game.queue.push('NOTIFY\tAll players have finished discarding');
                this.game.queue.push('discard\t' + JSON.stringify(playersToDiscard)); //One queue move all the players
              }
              eo = this.loadGamePreference('settlers_overlays');
              if (eo == null || eo) {
                if (this.game.state.robinhood) {
                  this.card_overlay.render({
                    player: this.game.state.robinhood,
                    card: 'Robin Hood'
                  });
                } else {
                  this.card_overlay.render({
                    player: _player16,
                    card: 'Bandit'
                  });
                }
              }
              return _context2.a(2, 1);
            case 35:
              return _context2.a(2, this.collectHarvest(roll, _player16));
            case 36:
              if (!(mv[0] == 'enable_trading')) {
                _context2.n = 37;
                break;
              }
              this.game.queue.splice(qe, 1);
              this.game.state.bandit = false;
              this.game.state.canTrade = true; //Toggles false when the player builds or buys
              this.game.state.hasRolled = true;
              return _context2.a(2, 1);
            case 37:
              if (!(mv[0] == 'discard')) {
                _context2.n = 39;
                break;
              }
              playersToGo = JSON.parse(mv[1]); //this.game.queue.splice(qe, 1); //Try not splicing
              discardString = '';
              confirmsNeeded = 0;
              amIPlaying = false;
              idx = 0;
              _iterator7 = _createForOfIteratorHelper(playersToGo);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  _i0 = _step7.value;
                  _i0 = parseInt(_i0);
                  idx++;
                  if (this.game.confirms_needed[_i0 - 1] == 1) {
                    if (idx > 1) {
                      discardString += ', ';
                    }
                    discardString += "".concat(this.game.playerNames[_i0 - 1]);
                    confirmsNeeded++;
                    if (this.game.player == _i0) {
                      this.addMove('RESOLVE\t' + this.publicKey);
                      this.discard.discardString = discardString;
                      this.discard.render();
                      amIPlaying = true;
                    }
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              if (!(confirmsNeeded == 0)) {
                _context2.n = 38;
                break;
              }
              this.game.queue.splice(qe, 1);
              return _context2.a(2, 1);
            case 38:
              this.game.queue.push("NOTIFY\t".concat(discardString, " must discard half their hand."));
              if (!amIPlaying) {
                this.updateStatus("waiting for ".concat(discardString, " to discard..."));
              }
              return _context2.a(2, 0);
            case 39:
              if (!(mv[0] == 'roll_bandit')) {
                _context2.n = 40;
                break;
              }
              player_who_rolled = parseInt(mv[1]);
              this.game.queue.splice(qe, 1);
              _player17 = player_who_rolled;
              if (this.game.state.robinhood) {
                _player17 = this.game.state.robinhood;
              }
              this.game.stats.move_bandit[_player17 - 1]++;

              //Move Bandit
              if (this.game.player == _player17) {
                this.playerPlayBandit(true);
              } else {
                if (_player17 == player_who_rolled) {
                  this.game.status = "".concat(this.game.playerNames[_player17 - 1], " moving the <span class=\"to-upper\">").concat(this.b.name, "</span>...");
                  this.hud.updateStatus(this.game.status);
                  this.hud.updateMenu([]);
                  this.hud.updateCards([]);
                } else {
                  this.updateStatus("ROBIN HOOD is on the loose, ".concat(this.game.playerNames[_player17 - 1], " moving him..."));
                  $('#settlers-hud-controls .option').css('visibility', 'hidden');
                }
              }
              return _context2.a(2, 0);
            case 40:
              if (!(mv[0] == 'move_bandit')) {
                _context2.n = 41;
                break;
              }
              _player18 = parseInt(mv[1]);
              hex = mv[2]; //Id of the sector_value
              this.game.queue.splice(qe, 1);

              //Move Bandit in DOM
              $('.bandit').removeClass('bandit');
              $('#' + hex).addClass('bandit');
              temp = hex.split('_'); // sector_value_3_3
              hexId = temp[2] + '_' + temp[3]; //Move Bandit in Game Logic
              for (h in this.game.state.hexes) {
                this.game.state.hexes[h].robber = h === hexId;
              }
              hexName = this.game.state.hexes[hexId].value + '->' + this.game.state.hexes[hexId].resource;
              this.updateLog("".concat(this.formatPlayer(_player18), " moved the ").concat(this.b.name, " to ").concat(hexName));
              this.game.state.threatened = [];
              _iterator8 = _createForOfIteratorHelper(this.game.state.cities);
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  _city = _step8.value;
                  if (_city.neighbours.includes(hexId)) {
                    if (!this.game.state.threatened.includes(_city.player)) {
                      this.game.state.threatened.push(_city.player);
                    }
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              console.log('Bandit moved:', JSON.stringify(this.game.state.threatened));
              if (this.game.player === _player18) {
                this.playerMoveBandit(_player18, hexId);
              } else {
                this.updateStatus("".concat(this.game.playerNames[_player18 - 1], " choosing the ").concat(this.b.name, "'s victim..."));
              }
              return _context2.a(2, 0);
            case 41:
              if (!(mv[0] == 'steal_card')) {
                _context2.n = 42;
                break;
              }
              thief = parseInt(mv[1]);
              victim = parseInt(mv[2]);
              loot = mv[3];
              this.game.queue.splice(qe, 1);
              if (victim > 0 && loot != 'nothing') {
                //victim 0 means nobody
                this.game.queue.push('spend_resource\t' + victim + '\t' + loot);
                this.game.state.players[thief - 1].resources.push(loot);

                //Adjust bandit stats
                this.game.stats.robbed[loot][victim - 1]++;
                // The spend_resource to remove from hand will count twice when we roll a 7 but not on a knight
                if (this.game.state.bandit) {
                  this.game.stats.discarded[loot][victim - 1]--;
                }
              }
              if (this.game.state.bandit) {
                _record = this.game.stats.history.pop();
                if (loot == 'nothing') {
                  _record.harvest[thief] = [];
                } else {
                  _record.harvest[thief] = [loot];
                }
                this.game.stats.history.push(_record);
              }
              x = loot == 'nothing' ? 'nothing' : this.formatResource(loot);
              if (this.game.player === thief) {
                this.updateStatus("<div class=\"player-notice\">you stole ".concat(x, "</div>"), 1);
              }
              if (this.game.player === victim) {
                this.game.status = "<div class=\"player-notice\">".concat(this.game.playerNames[thief - 1], " stole ").concat(x, " from you</div>"), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              victim_name = victim > 0 ? "".concat(this.formatPlayer(victim)) : '<span>nobody</span>';
              this.updateLog("".concat(this.formatPlayer(thief), " stole ").concat(x, "<span> from </span>").concat(victim_name));
              return _context2.a(2, 1);
            case 42:
              if (!(mv[0] == 'player_actions')) {
                _context2.n = 43;
                break;
              }
              _player19 = parseInt(mv[1]);
              if (_player19 == this.game.player) {
                this.playerPlayMove();
              } else {
                this.updateStatus("".concat(this.game.playerNames[_player19 - 1], " is taking their turn..."));
              }
              return _context2.a(2, 0);
            case 43:
              if (!(mv[0] == 'end_turn')) {
                _context2.n = 44;
                break;
              }
              this.game.state.canPlayCard = null;
              _player20 = parseInt(mv[1]); //
              //We put a lag in passing the length of the hand to the state.devcards
              //so that we can know that the last card in the hand is "new" and unable to be played until their next turn
              //
              while (this.game.deck[0].hand.length > 0) {
                this.game.state.players[this.game.player - 1].devcards.push(this.game.deck[0].hand.pop());
              }
              for (_i1 = 1; _i1 <= this.game.players.length; _i1++) {
                this.playerbox.updateGraphics('', _i1);
              }

              // Only set initial flag to true at end of opponents turn, because we loop back to "play"
              // when playing a knight and don't want to allow multiple knights before the roll
              if (this.game.state.players[this.game.player - 1].devcards.length > 0) {
                this.game.state.canPlayCard = true;
              }
              if (_player20 == this.game.player) {
                this.updateStatus("<div class=\"player-notice\">you passed the die</div>", 1);
              } else {
                this.game.status = "<div class=\"player-notice\">".concat(this.game.playerNames[_player20 - 1], " passed the die</div>"), 1;
                this.hud.updateStatus(this.game.status);
                this.hud.updateMenu([]);
                this.hud.updateCards([]);
              }
              this.game.state.hasRolled = false;
              this.game.state.canTrade = false;
              this.game.queue.splice(qe - 1, 2);
              console.log('CLEAR FORMATTING!!!!');
              $('.sector_value').attr('style', '');
              $('.rolled').removeClass('rolled');
              return _context2.a(2, 1);
            case 44:
              return _context2.a(2, 1);
          }
        }, _callee, this);
      }));
      function handleGameLoop() {
        return _handleGameLoop.apply(this, arguments);
      }
      return handleGameLoop;
    }())
  }]);
}();
module.exports = SettlersGameloop;